import React from 'react'
import styles from './HomeCard.module.css';

const HomeCard = ({ img, text, heading }) => {
    return (
        <div className={styles.container}>
            <img src={img} alt="card-pic" />
            <div className={styles.textContainer}>
                <h3>Scatole | Pallet</h3>
                <p>Arrange delivery of anything, anytime and anywhere.</p>
            </div>
        </div>
        
    )
}

export default HomeCard
